import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "FindStoresLazy" */ './FindStores'), {
    fallback: null,
});
